// extracted by mini-css-extract-plugin
export default {"card":"Questionnaire_card__tKNWW","radio":"Questionnaire_radio__SlSzL"};